module.exports = __webpack_public_path__ + "img/tx_kit.b185d348.svg";